import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from 'design-system';
import {
  TableHead,
  TableRow,
  Table,
  TableCell,
} from 'react-scale/components/design-system/product';
import Typography from '@mui/material/Typography';
import _ from 'lodash';

interface AuditClaimedTasksDialogProps {
  claimedTasksInfo: Record<string, string>[];
  setClaimedTasksInfo: (value: Record<string, string>[]) => void;
  handleRefreshClaims: (forceClaim: boolean) => Promise<void>;
}

const AuditClaimedTasksDialog: React.FC<AuditClaimedTasksDialogProps> = ({
  claimedTasksInfo,
  setClaimedTasksInfo,
  handleRefreshClaims,
}) => {
  return (
    <Dialog open={!_.isEmpty(claimedTasksInfo)} onClose={() => setClaimedTasksInfo([])}>
      <DialogTitle>Refresh claimed on newly claimed tasks?</DialogTitle>
      <DialogContent>
        <div>
          It seems like some tasks that were claimed via this audit are now not claimed by you
          anymore.
          <Typography variant="h6">Currently Claimed Tasks/Subtasks in this Audit:</Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">ObjectId</TableCell>
                <TableCell align="left">Claimed By</TableCell>
                <TableCell align="left">Claimed Until</TableCell>
              </TableRow>
            </TableHead>
            {claimedTasksInfo.map(info => (
              <TableRow key={info.id}>
                <TableCell>{info.id}</TableCell>
                <TableCell>{info.claimedBy}</TableCell>
                <TableCell>{info.claimedUntil}</TableCell>
              </TableRow>
            ))}
          </Table>
        </div>
        <div style={{ marginTop: '8px' }}>
          <Typography variant="h6">Warning:</Typography>
          If you choose to refresh your claim on these tasks, you will also override the current
          claim.
        </div>
      </DialogContent>
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button
          type="secondary"
          variant="outlined"
          onClick={async () => {
            await handleRefreshClaims(true);
          }}
        >
          Refresh claims on all tasks
        </Button>
        <Button type="primary" onClick={() => setClaimedTasksInfo([])}>
          Don't refresh claims
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuditClaimedTasksDialog;
